export enum EMessageType {
  text = 'text',
  video = 'video',
  audio = 'audio',
  error = 'error',
  image = 'image',
}

export enum WorkspaceRoles {
  OWNER = 'OWNER',
  EDITOR = 'CAN_EDIT',
  VIEWER = 'CAN_VIEW',
}

export enum HttpMethod {
  GET = 'get',
}

export enum OrganizationRoles {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  ADMIN = 'ADMIN',
}

export enum EProjectStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  REQUEST_APPROVED = 'REQUEST_APPROVED',
  PUBLISHED = 'PUBLISHED',
  COMPLETED = 'COMPLETED',
}

export enum EPanelIntegration {
  NONE = 'NONE',
  TESTING_TIME = 'TESTING_TIME',
}

export enum EStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  INVALID_CREDENTIALS = 401,
  INVALID_ROLE = 410,
  PROJECT_NOT_READY = 421,
  CANT_DELETE_PUBLISHED = 430,
  PROJECT_NOT_FOUND = 431,
  LABELS_MUST_BE_UNIQUE = 439,
}

export enum ECompanyThemeName {
  DEFAULT = 'default',
  EMPATHY = 'empathyiq',
}

export enum ECategoryMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export enum ECreateThemeModalType {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum EProjectDesignSection {
  INSTRUCTIONS = 'Instructions',
  CONTEXT = 'Context',
  DISCUSSION_GUIDE = 'Discussion Guide',
  SCREENING = 'Screening',
  MAX_RESPONDENTS = 'Max Participants',
}

export enum ScreeningRulesTypes {
  QUALIFY = 'qualify',
  IRRELEVANT = 'irrelevant',
  DISQUALIFY = 'disqualify',
}

export enum PrescreenState {
  QUALIFIED = 'qualified',
  DISQUALIFIED = 'disqualified',
  QUOTA_FULL = 'quota_full',
}

export enum ScreeningQuestionType {
  MULTI_SELECT = 'multiSelect',
  SINGLE_SELECT = 'singleSelect',
  NUMERIC = 'numericInput',
  MAX_RESPONDENTS = 'Max Participants',
}

export enum EFilterType {
  TEXT = 'text',
  NUMERIC = 'numeric',
  // NUMBER_RANGE is only for handling missmatch while prepopulating existing filters data
  NUMBER_RANGE = 'numberRange',
  DATE = 'date',
}

export enum EDateTypes {
  RANGE = 'Range',
  BEFORE = 'Before',
  AFTER = 'After',
}

export enum EFilterSelectionType {
  NUMBER_RANGE = 'numberRange',
  DATE = 'date',
  TEXT = 'text',
}

export enum NavigationTabs {
  OVERVIEW = 'overview_tab',
  QUESTIONS = 'questions_tab',
  TRANSCRIPTS = 'transcripts_tab',
  AISEARCH = 'ai_search_tab',
  COMPARE = 'compare_tab',
  REPORTS = 'reports_tab',
}

export enum ECookieKey {
  TOKEN = 'token',
  FALLBACK_WORKSPACE = 'fallback_workspace',
  MAIN_ORGANIZATION = 'main_organization',
  REMEMBER_ME = 'remember_me',
}

export enum CategoryDisplayType {
  TALLY = 'tally',
  PERCENTAGE = 'percentage',
  PIE = 'pie',
}

export enum CategorySortType {
  ASC = 'ascending',
  DESC = 'descending',
  DEFAULT = 'default',
}

export enum EScreeningRulesTypes {
  QUALIFY = 'Qualify',
  IRRELEVANT = 'Irrelevant',
  DISQUALIFY = 'Disqualify',
}

export enum EScreeningQuestionType {
  MULTI_SELECT = 'Multi-select',
  SINGLE_SELECT = 'Single-select',
  NUMERIC = 'Numeric',
}

export enum TranscriptsView {
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
  SCREENED_OUT = 'screened_out',
}

export enum QuestionsTab {
  INSIGHTS = 'insights',
  ANSWERS = 'answers',
}

export enum TwoFactorSetupStep {
  INITIAL = 'initial',
  QR_CODE = 'qrcode',
  BACKUP_CODES = 'backupCodes',
}

export enum ConversationView {
  CONVERSATION_OVERVIEW = 'conversation_overview',
  CONVERSATION_DETAILS = 'conversation_details',
  SINGLE_CONVERSATION = 'single_conversation',
  FULL_ANSWERS_TRANSCRIPT = 'full_answers_transcript',
}

export enum ConversationState {
  DONE = 'done',
  IDLE = 'idle',
  LOADING = 'loading',
}

export enum WorkspaceType {
  PRIVATE = 'priv',
  SHARED = 'shared',
}

export enum ConversationNavigationType {
  NEXT = 'next',
  PREV = 'prev',
}
export enum GroupContentType {
  QUESTIONS = 'questions',
  GROUPS = 'groups',
  EMPTY = 'empty',
}

export enum QuestionGroupLimits {
  MAX_QUESTIONS = 40,
  MAX_GROUPS = 20,
}
